import i18n from "@/lib/i18n";
import * as React from "react";

interface DescriptionSectionProps {
  description: string;
  className?: string;
}

export const DescriptionSection: React.FC<DescriptionSectionProps> = ({
  description,
  className,
}) => (
  <div className={`border border-slate-200 rounded-lg ${className || ""}`}>
    <div className="bg-slate-50 border-b border-slate-200 px-6 py-4">
      <h3 className="text-lg font-semibold text-slate-900">{i18n.t("features.quotes.quoteViewer.sections.descriptionSection.workDescription")}</h3>
    </div>
    <div className="p-6">
      <p className="whitespace-pre-line text-slate-700 leading-relaxed">
        {description}
      </p>
    </div>
  </div>
);
